import React, { useState, useRef } from "react";
import cx from "classnames";
import s from "./paginationFilter.scss";
import { Icon, search, close } from "Icons/index";
import { t } from "i18next";
import { useHistory } from "react-router-dom";
import qs from "query-string";

const PaginationFilter = ({
  currentQuery = "",
  paginationFilter = {},
  url,
  className,
  placeholder,
  disabled = false,
}) => {
  const [value, setValue] = useState(currentQuery);
  const inputRef = useRef(null);
  const history = useHistory();

  const filterBy = (query = "") => {
    const trimmed = query.trim();
    setValue(trimmed);
    if (inputRef.current) inputRef.current.blur();
    const q = {
      ...paginationFilter,
      page: 1,
      per: 25,
      query: trimmed,
    };
    history.push({
      pathname: url,
      search: qs.stringify(q),
      state: { prevPathname: url },
    });
  };

  const handleFilter = () => filterBy(value);

  const handleKeyUp = (e) => {
    if (e.keyCode === 13) {
      filterBy(value);
    }
  };

  const handleChange = (e) => setValue(e.currentTarget.value);

  const handleReset = () => {
    setValue("");
    filterBy();
  };

  return (
    <div className={cx(className, s.wrapInput)}>
      <input
        disabled={disabled}
        ref={inputRef}
        placeholder={placeholder || t("input.placeholder.filters")}
        onChange={handleChange}
        value={value}
        onKeyUp={handleKeyUp}
        className={cx(s.input, { [s.active]: currentQuery })}
      />
      <div className={s.iconContainer}>
        {currentQuery === value && value !== "" ? (
          <Icon svg={close} width="0.875rem" height="0.875rem" onClick={handleReset} className={cx(s.icon)} />
        ) : (
          <Icon svg={search} width="0.875rem" height="0.875rem" onClick={handleFilter} className={cx(s.icon)} />
        )}
      </div>
    </div>
  );
};

export default PaginationFilter;
